// Vary the house emoji by order so two houses read as distinct at
// a glance, even for a kid who can't read names yet. Skip the
// dilapidated 🏚️ — not the vibe.
const PALETTE = ["🏡", "🏠", "🏘️"];

export function houseEmoji(index) {
  const i = Math.max(0, index | 0);
  return PALETTE[i % PALETTE.length];
}
